import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek.js';
import type { IntlShape } from 'react-intl';
import { PERIOD_KEYS } from './constants';
import type { Period } from './types';

dayjs.extend(isoWeek);

export function getPeriodByKey(key: string, formatMessage: IntlShape['formatMessage']): Period {
  switch (key) {
    case PERIOD_KEYS.TODAY:
      return {
        key,
        label: formatMessage({ id: 'shared-kit.period-selector.options.today' }),
        startDate: dayjs().startOf('day').format('YYYY-MM-DD'),
        endDate: dayjs().endOf('day').format('YYYY-MM-DD'),
      };
    case PERIOD_KEYS.YESTERDAY:
      return {
        key,
        label: formatMessage({ id: 'shared-kit.period-selector.options.yesterday' }),
        startDate: dayjs().subtract(1, 'day').startOf('day').format('YYYY-MM-DD'),
        endDate: dayjs().subtract(1, 'day').endOf('day').format('YYYY-MM-DD'),
      };
    case PERIOD_KEYS.THIS_WEEK:
      return {
        key,
        label: formatMessage({ id: 'shared-kit.period-selector.options.this-week' }),
        startDate: dayjs().startOf('isoWeek').format('YYYY-MM-DD'),
        endDate: dayjs().endOf('isoWeek').format('YYYY-MM-DD'),
      };
    case PERIOD_KEYS.THIS_MONTH:
      return {
        key,
        label: formatMessage({ id: 'shared-kit.period-selector.options.this-month' }),
        startDate: dayjs().startOf('month').format('YYYY-MM-DD'),
        endDate: dayjs().endOf('month').format('YYYY-MM-DD'),
      };
    case PERIOD_KEYS.THIS_YEAR:
      return {
        key,
        label: formatMessage({ id: 'shared-kit.period-selector.options.this-year' }),
        startDate: dayjs().startOf('year').format('YYYY-MM-DD'),
        endDate: dayjs().endOf('year').format('YYYY-MM-DD'),
      };
    case PERIOD_KEYS.CUSTOM_PERIOD:
      return {
        key,
        label: formatMessage({ id: 'shared-kit.period-selector.options.custom.label' }),
        startDate: null,
        endDate: null,
      };
    default:
      throw new Error(`Unknown period key: ${key}`);
  }
}
